import React, { createContext, useContext, useState, useCallback } from 'react';

const ActiveRequestContext = createContext();

export const ActiveRequestProvider = ({ children }) => {
  const [resetTrigger, setResetTrigger] = useState(0);

  const resetActiveRequest = useCallback(() => {
    // Increment trigger to force re-render and reset
    setResetTrigger(prev => prev + 1);
  }, []);

  return (
    <ActiveRequestContext.Provider value={{ resetActiveRequest, resetTrigger }}>
      {children}
    </ActiveRequestContext.Provider>
  );
};

export const useActiveRequest = () => {
  const context = useContext(ActiveRequestContext);
  // Return a default context if not available (for components that don't need it)
  if (!context) {
    return { resetActiveRequest: () => {}, resetTrigger: 0 };
  }
  return context;
};

